import { FC, useEffect, useState } from "react";
import "./home/addBook.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Book, Props } from "./types";
import { BookRow } from "./home/BookRow";
import { GoBack } from "./components/GoBack";
import { track } from "@amplitude/analytics-browser";
import { CircularProgress } from "@mui/material";
import * as amplitude from "@amplitude/analytics-browser";

export const AddBook: FC<Props> = ({
  setBooks,
  books,
  setLastBooksRead,
  lastBooksRead,
}) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [bookClicked, setBookClicked] = useState<Book | undefined>();
  const [pages, setPages] = useState<number>(0);
  const [typingTimeout, setTypingTimeout] = useState<number>();
  const [searchResults, setSearchResults] = useState<Book[]>();
  const navigate = useNavigate();
  useEffect(() => {
    track("addBookScreen");
  }, []);
  const onSelectBook = (book: Book) => {
    if (!book.pages) {
      setBookClicked(book);
      return;
    }
    track("AddBook: selected book", book);
    setLastBooksRead(book.id);
    if (!books[book.id]) {
      //create new record
      setBooks((bs) => {
        return { ...bs, [book.id]: { ...book, readingSessions: [] } };
      });
    }
    const identifyEvent = new amplitude.Identify();
    identifyEvent.add("user-books", 1);
    amplitude.identify(identifyEvent);
    navigate(`/tracker/${book.id}`);
  };

  const fetchBooks = async (input: string) => {
    setLoading(true);
    track("AddBook: fetchBooks", { input });

    try {
      const response = await axios.get(
        "https://www.googleapis.com/books/v1/volumes",
        {
          params: {
            q: input,
            printType: "books",
            // orderBy: "newest",
            maxResults: "15",
            // langRestrict: "es+cat+en",
            // filter: "full",
          },
          headers: {
            "X-goog-api-key": process.env.REACT_APP_GOOGLE_BOOKS_API,
          },
        }
      );
      const books = response?.data?.items?.map((row: any) => {
        const info = row.volumeInfo;
        if (
          // !info.pageCount ||
          !info.title ||
          !info.imageLinks?.smallThumbnail
        ) {
          return null;
        }
        return {
          id: row.id,
          title: info.title,
          author: info.authors?.[0],
          published_date: new Date(info.publishedDate),
          isbn: info.industryIdentifiers?.[1]?.identifier,
          pages: info.pageCount ?? 0,
          imageLink: info.imageLinks,
        };
      });
      const booksfiltered = books.filter((a: Book | null) => Boolean(a));
      setSearchResults(booksfiltered);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleSearch = (input: string) => {
    clearTimeout(typingTimeout);
    setTypingTimeout(
      window.setTimeout(() => {
        fetchBooks(input);
      }, 1000)
    );
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      clearTimeout(typingTimeout);
      fetchBooks(search);
    }
  };
  return (
    <>
      {bookClicked && (
        <div className="setPagesPopUp">
          we couldn't find the number of pages for this book
          <input
            type="number"
            value={pages || ""}
            onChange={(e) => setPages(parseInt(e.target.value))}
            placeholder="number of pages..."
          />
          <button
            onClick={() => {
              onSelectBook({ ...bookClicked, pages: pages });
            }}
          >
            Save
          </button>
          <button
            style={{
              backgroundColor: "transparent",
              color: "#333",
              border: "1px solid #333 ",
              borderRadius: "4px",
            }}
            onClick={() => {
              setBookClicked(undefined);
            }}
          >
            Cancel
          </button>
        </div>
      )}
      <GoBack />
      <p className="secctionTitle">Add new book to track</p>
      <input
        value={search}
        placeholder="title, author,..."
        onChange={(e) => {
          setSearch(e.target.value);
          handleSearch(e.target.value);
        }}
        style={{ outlineColor: "#ea8b8b" }}
        onKeyDown={handleKeyDown}
      />
      <div className="listBooks">
        {loading ? (
          <CircularProgress sx={{ color: "#EA8B8B" }} />
        ) : searchResults && searchResults.length > 0 ? (
          searchResults?.map((row) => {
            return (
              <BookRow
                key={`${row.id}-${row.title}`}
                book={row}
                onClick={() => {
                  onSelectBook(row);
                }}
              />
            );
          })
        ) : (
          <p>no results found</p>
        )}
      </div>
    </>
  );
};
